/*
 * Gets question definitions as downloaded via fetchInitial [filtered to q data specific]
 */
import type { RootState } from '/business/shared/state/store';
import { EMPTY_ARRAY } from '/business/shared/state/selectors/util';

export default (state: RootState) => state.staticProps?.questionStatics ?? EMPTY_ARRAY;
